var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3AxSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2830.97 803.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbb040;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99,.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-150,.cls-151,.cls-152,.cls-153,.cls-154,.cls-155,.cls-156,.cls-157,.cls-158,.cls-159,.cls-160,.cls-161,.cls-162,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167,.cls-168,.cls-169,.cls-170,.cls-171,.cls-172,.cls-173,.cls-174,.cls-175,.cls-176{stroke-width:0px;}.cls-2{fill:#1b75bc;}.cls-2,.cls-6,.cls-7,.cls-52,.cls-57,.cls-146,.cls-177,.cls-153,.cls-156,.cls-157,.cls-159,.cls-160,.cls-170,.cls-173,.cls-175{mix-blend-mode:multiply;}.cls-3,.cls-173{fill:#414042;}.cls-4{fill:url(#New_Gradient_Swatch_4);}.cls-5{fill:url(#New_Gradient_Swatch_3);}.cls-6{fill:url(#linear-gradient-89);}.cls-7{fill:url(#linear-gradient-90);}.cls-8{fill:url(#New_Gradient_Swatch_3-3);}.cls-9{fill:url(#New_Gradient_Swatch_3-4);}.cls-10{fill:url(#New_Gradient_Swatch_3-9);}.cls-11{fill:url(#New_Gradient_Swatch_3-8);}.cls-12{fill:url(#New_Gradient_Swatch_3-7);}.cls-13{fill:url(#New_Gradient_Swatch_3-6);}.cls-14{fill:url(#New_Gradient_Swatch_3-2);}.cls-15{fill:url(#New_Gradient_Swatch_3-5);}.cls-16{fill:url(#New_Gradient_Swatch_4-3);}.cls-17{fill:url(#New_Gradient_Swatch_4-2);}.cls-18{fill:#f7941d;}.cls-19{fill:url(#linear-gradient-120);}.cls-20{fill:url(#linear-gradient-125);}.cls-21{fill:url(#linear-gradient-124);}.cls-22{fill:url(#linear-gradient-126);}.cls-23{fill:url(#linear-gradient-131);}.cls-24{fill:url(#linear-gradient-132);}.cls-25{fill:url(#linear-gradient-130);}.cls-26{fill:url(#linear-gradient-133);}.cls-27{fill:url(#linear-gradient-100);}.cls-28{fill:url(#linear-gradient-101);}.cls-29{fill:url(#linear-gradient-123);}.cls-30{fill:url(#linear-gradient-129);}.cls-31{fill:url(#linear-gradient-121);}.cls-32{fill:url(#linear-gradient-122);}.cls-33{fill:url(#linear-gradient-109);}.cls-34{fill:url(#linear-gradient-108);}.cls-35{fill:url(#linear-gradient-106);}.cls-36{fill:url(#linear-gradient-107);}.cls-37{fill:url(#linear-gradient-102);}.cls-38{fill:url(#linear-gradient-104);}.cls-39{fill:url(#linear-gradient-103);}.cls-40{fill:url(#linear-gradient-105);}.cls-41{fill:url(#linear-gradient-117);}.cls-42{fill:url(#linear-gradient-118);}.cls-43{fill:url(#linear-gradient-111);}.cls-44{fill:url(#linear-gradient-112);}.cls-45{fill:url(#linear-gradient-128);}.cls-46{fill:url(#linear-gradient-110);}.cls-47{fill:url(#linear-gradient-113);}.cls-48{fill:url(#linear-gradient-114);}.cls-49{fill:url(#linear-gradient-115);}.cls-50{fill:url(#linear-gradient-116);}.cls-51{fill:url(#linear-gradient-119);}.cls-178{mask:url(#mask);}.cls-52{fill:#fff;}.cls-53,.cls-156{fill:#ed1c24;}.cls-179{filter:url(#luminosity-noclip);}.cls-54{fill:#ef4136;}.cls-55{fill:#6d6e71;}.cls-56{fill:#f15a29;}.cls-57{fill:url(#linear-gradient);}.cls-58{fill:url(#linear-gradient-38);}.cls-59{fill:url(#linear-gradient-33);}.cls-60{fill:url(#linear-gradient-29);}.cls-61{fill:url(#linear-gradient-32);}.cls-62{fill:url(#linear-gradient-30);}.cls-63{fill:url(#linear-gradient-31);}.cls-64{fill:url(#linear-gradient-36);}.cls-65{fill:url(#linear-gradient-39);}.cls-66{fill:url(#linear-gradient-34);}.cls-67{fill:url(#linear-gradient-37);}.cls-68{fill:url(#linear-gradient-35);}.cls-69{fill:url(#linear-gradient-28);}.cls-70{fill:url(#linear-gradient-25);}.cls-71{fill:url(#linear-gradient-11);}.cls-72{fill:url(#linear-gradient-12);}.cls-73{fill:url(#linear-gradient-13);}.cls-74{fill:url(#linear-gradient-10);}.cls-75{fill:url(#linear-gradient-17);}.cls-76{fill:url(#linear-gradient-16);}.cls-77{fill:url(#linear-gradient-19);}.cls-78{fill:url(#linear-gradient-15);}.cls-79{fill:url(#linear-gradient-23);}.cls-80{fill:url(#linear-gradient-21);}.cls-81{fill:url(#linear-gradient-18);}.cls-82{fill:url(#linear-gradient-14);}.cls-83{fill:url(#linear-gradient-22);}.cls-84{fill:url(#linear-gradient-20);}.cls-85{fill:url(#linear-gradient-27);}.cls-86{fill:url(#linear-gradient-24);}.cls-87{fill:url(#linear-gradient-26);}.cls-88{fill:url(#linear-gradient-45);}.cls-89{fill:url(#linear-gradient-46);}.cls-90{fill:url(#linear-gradient-44);}.cls-91{fill:url(#linear-gradient-48);}.cls-92{fill:url(#linear-gradient-49);}.cls-93{fill:url(#linear-gradient-47);}.cls-94{fill:url(#linear-gradient-42);}.cls-95{fill:url(#linear-gradient-43);}.cls-96{fill:url(#linear-gradient-40);}.cls-97{fill:url(#linear-gradient-41);}.cls-98{fill:url(#linear-gradient-59);}.cls-99{fill:url(#linear-gradient-57);}.cls-100{fill:url(#linear-gradient-58);}.cls-101{fill:url(#linear-gradient-55);}.cls-102{fill:url(#linear-gradient-56);}.cls-103{fill:url(#linear-gradient-53);}.cls-104{fill:url(#linear-gradient-51);}.cls-105{fill:url(#linear-gradient-52);}.cls-106{fill:url(#linear-gradient-50);}.cls-107{fill:url(#linear-gradient-54);}.cls-108{fill:url(#linear-gradient-60);}.cls-109{fill:url(#linear-gradient-61);}.cls-110{fill:url(#linear-gradient-62);}.cls-111{fill:url(#linear-gradient-65);}.cls-112{fill:url(#linear-gradient-79);}.cls-113{fill:url(#linear-gradient-78);}.cls-114{fill:url(#linear-gradient-77);}.cls-115{fill:url(#linear-gradient-75);}.cls-116{fill:url(#linear-gradient-76);}.cls-117{fill:url(#linear-gradient-74);}.cls-118{fill:url(#linear-gradient-67);}.cls-119{fill:url(#linear-gradient-68);}.cls-120{fill:url(#linear-gradient-66);}.cls-121{fill:url(#linear-gradient-63);}.cls-122{fill:url(#linear-gradient-69);}.cls-123{fill:url(#linear-gradient-64);}.cls-124{fill:url(#linear-gradient-71);}.cls-125{fill:url(#linear-gradient-72);}.cls-126{fill:url(#linear-gradient-70);}.cls-127{fill:url(#linear-gradient-73);}.cls-128{fill:url(#linear-gradient-84);}.cls-129{fill:url(#linear-gradient-85);}.cls-130{fill:url(#linear-gradient-82);}.cls-131{fill:url(#linear-gradient-83);}.cls-132{fill:url(#linear-gradient-88);}.cls-133{fill:url(#linear-gradient-86);}.cls-134{fill:url(#linear-gradient-87);}.cls-135{fill:url(#linear-gradient-80);}.cls-136{fill:url(#linear-gradient-81);}.cls-137{fill:url(#linear-gradient-98);}.cls-138{fill:url(#linear-gradient-91);}.cls-139{fill:url(#linear-gradient-92);}.cls-140{fill:url(#linear-gradient-93);}.cls-141{fill:url(#linear-gradient-96);}.cls-142{fill:url(#linear-gradient-97);}.cls-143{fill:url(#linear-gradient-94);}.cls-144{fill:url(#linear-gradient-95);}.cls-145{fill:url(#linear-gradient-99);}.cls-146,.cls-152,.cls-161{fill:#000;}.cls-147{fill:#f1f2f2;}.cls-148{fill:#58595b;}.cls-149,.cls-157{fill:#bcbec0;}.cls-150,.cls-153{fill:#808285;}.cls-151{fill:url(#New_Gradient_Swatch_3-10);}.cls-154,.cls-159{fill:#a7a9ac;}.cls-155{fill:url(#New_Gradient_Swatch_11_cop);}.cls-158{fill:#be1e2d;}.cls-160,.cls-172{fill:#e6e7e8;}.cls-161{opacity:.5;}.cls-162{fill:url(#linear-gradient-4);}.cls-163{fill:url(#linear-gradient-2);}.cls-164{fill:url(#linear-gradient-3);}.cls-165{fill:url(#linear-gradient-8);}.cls-166{fill:url(#linear-gradient-9);}.cls-167{fill:url(#linear-gradient-7);}.cls-168{fill:url(#linear-gradient-5);}.cls-169{fill:url(#linear-gradient-6);}.cls-170{fill:url(#linear-gradient-127);}.cls-171,.cls-175{fill:#939598;}.cls-180{isolation:isolate;}.cls-174{fill:#d1d3d4;}.cls-176{fill:#231f20;}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 3.45,
    y: 716.3,
    width: 2824.07,
    height: 87.31,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 3.45,
    y: 716.3,
    width: 2824.07,
    height: 87.31,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-179"
  }, /*#__PURE__*/React.createElement("image", {
    width: 2825,
    height: 88,
    transform: "translate(2.98 716.07)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1779.07,
    y1: 540.94,
    x2: 1779.07,
    y2: 457.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#9c9b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#545152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1267.93,
    y1: 670.46,
    x2: 1267.93,
    y2: 514.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e0001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#310000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3",
    x1: 1267.93,
    y1: 683.23,
    x2: 1267.93,
    y2: 691.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-2",
    y1: 651.72,
    y2: 682.75,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-3",
    x1: 1267.93,
    y1: 495.78,
    x2: 1267.93,
    y2: 636.74,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -4373.66,
    y1: 449.26,
    x2: -4373.66,
    y2: 352.93,
    gradientTransform: "translate(-3859.64) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#b7b8ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -4336.24,
    y1: 490.56,
    x2: -4336.24,
    y2: 311.88,
    gradientTransform: "translate(-3859.64) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#262224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#525254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#515254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#403f41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#252122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -4314.76,
    y1: 308.9,
    x2: -4314.76,
    y2: 493.36,
    gradientTransform: "translate(-3859.64) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2b2729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3b393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3a393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2a2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: 308.9,
    y2: 493.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: 308.9,
    y2: 493.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    y1: 308.89,
    y2: 493.37,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 308.89,
    y2: 493.37,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    y1: 308.9,
    y2: 493.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    y1: 308.89,
    y2: 493.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    y1: 308.9,
    y2: 493.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    y1: 308.89,
    y2: 493.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    y1: 308.89,
    y2: 493.37,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    y1: 308.89,
    y2: 493.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    y1: 308.89,
    y2: 493.37,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    y1: 308.89,
    y2: 493.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    y1: 308.89,
    y2: 493.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    y1: 308.9,
    y2: 493.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(4769.88 618.91) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(4769.88 624.06) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(4769.88 630.42) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    y1: 308.89,
    y2: 493.35,
    gradientTransform: "translate(4769.88 638.08) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(4769.88 647.07) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(4769.88 657.16) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(4769.88 668.33) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(4769.88 680.43) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    y1: 308.9,
    y2: 493.36,
    gradientTransform: "translate(4769.88 693.77) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(4769.88 707.63) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(4769.88 722.49) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    y1: 308.9,
    y2: 493.36,
    gradientTransform: "translate(4769.88 737.8) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(4769.88 753.83) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(4769.88 770.06) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(4769.88 786.51) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -4314.76,
    y1: 308.9,
    x2: -4314.76,
    y2: 493.36,
    gradientTransform: "translate(4769.88 802.19) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -4357.73,
    x2: -4357.73,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -4357.73,
    y1: 308.9,
    x2: -4357.73,
    y2: 493.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -4357.73,
    y1: 308.9,
    x2: -4357.73,
    y2: 493.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -4357.73,
    y1: 308.89,
    x2: -4357.73,
    y2: 493.37,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -4357.73,
    y1: 308.89,
    x2: -4357.73,
    y2: 493.37,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -4357.73,
    y1: 308.9,
    x2: -4357.73,
    y2: 493.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -4357.73,
    y1: 308.89,
    x2: -4357.73,
    y2: 493.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -4357.73,
    y1: 308.9,
    x2: -4357.73,
    y2: 493.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -4357.73,
    y1: 308.89,
    x2: -4357.73,
    y2: 493.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -4357.73,
    y1: 308.89,
    x2: -4357.73,
    y2: 493.37,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -4357.73,
    y1: 308.89,
    x2: -4357.73,
    y2: 493.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -4357.73,
    y1: 308.89,
    x2: -4357.73,
    y2: 493.37,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -4357.73,
    y1: 308.89,
    x2: -4357.73,
    y2: 493.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -4357.73,
    y1: 308.89,
    x2: -4357.73,
    y2: 493.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -4357.73,
    y1: 308.9,
    x2: -4357.73,
    y2: 493.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -4357.73,
    y1: 308.89,
    x2: -4357.73,
    y2: 493.36,
    gradientTransform: "translate(4855.82 618.91) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -4357.73,
    y1: 308.89,
    x2: -4357.73,
    y2: 493.36,
    gradientTransform: "translate(4855.82 624.06) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -4357.73,
    y1: 308.89,
    x2: -4357.73,
    y2: 493.37,
    gradientTransform: "translate(4855.82 630.42) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -4357.73,
    y1: 308.89,
    x2: -4357.73,
    y2: 493.35,
    gradientTransform: "translate(4855.82 638.08) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -4357.73,
    y1: 308.89,
    x2: -4357.73,
    y2: 493.36,
    gradientTransform: "translate(4855.82 647.07) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -4357.73,
    y1: 308.89,
    x2: -4357.73,
    y2: 493.36,
    gradientTransform: "translate(4855.82 657.16) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -4357.73,
    y1: 308.89,
    x2: -4357.73,
    y2: 493.36,
    gradientTransform: "translate(4855.82 668.33) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -4357.73,
    y1: 308.89,
    x2: -4357.73,
    y2: 493.37,
    gradientTransform: "translate(4855.82 680.43) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -4357.73,
    y1: 308.9,
    x2: -4357.73,
    y2: 493.36,
    gradientTransform: "translate(4855.82 693.77) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -4357.73,
    y1: 308.89,
    x2: -4357.73,
    y2: 493.37,
    gradientTransform: "translate(4855.82 707.63) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -4357.73,
    y1: 308.89,
    x2: -4357.73,
    y2: 493.37,
    gradientTransform: "translate(4855.82 722.49) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -4357.73,
    y1: 308.9,
    x2: -4357.73,
    y2: 493.36,
    gradientTransform: "translate(4855.82 737.8) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -4357.73,
    y1: 308.89,
    x2: -4357.73,
    y2: 493.36,
    gradientTransform: "translate(4855.82 753.83) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -4357.73,
    y1: 308.89,
    x2: -4357.73,
    y2: 493.36,
    gradientTransform: "translate(4855.82 770.06) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -4357.73,
    y1: 308.89,
    x2: -4357.73,
    y2: 493.37,
    gradientTransform: "translate(4855.82 786.51) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -4357.73,
    y1: 308.9,
    x2: -4357.73,
    y2: 493.36,
    gradientTransform: "translate(4855.82 802.19) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -4336.24,
    y1: 310.39,
    x2: -4336.24,
    y2: 493.86,
    gradientTransform: "translate(4812.85 802.19) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4",
    x1: 261.18,
    y1: 717.26,
    x2: 261.18,
    y2: 530.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-4",
    x1: 261.18,
    y1: 547.37,
    x2: 261.18,
    y2: 706.15,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 261.18,
    y1: 574.21,
    x2: 261.18,
    y2: 673.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    y1: 653.93,
    y2: 593.73,
    gradientTransform: "translate(791.65 204.21) rotate(74.35)",
    xlinkHref: "#linear-gradient-68"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 261.18,
    y1: 682.04,
    x2: 261.18,
    y2: 567.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 261.18,
    y1: 607.68,
    x2: 261.18,
    y2: 642.15,
    gradientTransform: "translate(333.62 -48.56) rotate(28.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 261.18,
    y1: 637.74,
    x2: 261.18,
    y2: 610.89,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 628.74,
    y1: 534.08,
    x2: 628.74,
    y2: 635.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#cccecf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#bec0c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a8aaad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#919396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#818285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#757679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6e6f72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 560.5,
    y1: 623.01,
    x2: 560.5,
    y2: 641.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#383739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#212122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 628.74,
    x2: 628.74,
    xlinkHref: "#linear-gradient-74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 696.98,
    x2: 696.98,
    xlinkHref: "#linear-gradient-74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 648.87,
    y1: 540.6,
    x2: 673.27,
    y2: 540.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#0b0b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#28292a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#58595c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-2",
    x1: 985.06,
    x2: 985.06,
    y2: 530.05,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-5",
    x1: 985.06,
    y1: 547.37,
    x2: 985.06,
    y2: 706.15,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 985.06,
    x2: 985.06,
    y2: 567.07,
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 985.03,
    y1: 573.42,
    x2: 985.03,
    y2: 673.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#68696b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#929495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 985.06,
    y1: 642.51,
    x2: 985.06,
    y2: 605.26,
    gradientTransform: "translate(313.81 -329.46) rotate(22.5)",
    xlinkHref: "#linear-gradient-71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 985.06,
    y1: 637.62,
    x2: 985.06,
    y2: 611,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 478.29,
    y1: 372.9,
    x2: 478.29,
    y2: 503.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e2e3e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#d9dadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#c8cacc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 414.15,
    y1: 568.88,
    x2: 414.15,
    y2: 487.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#1f0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4a0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#640000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 41.69,
    y1: 3180.58,
    x2: 41.69,
    y2: 3099.01,
    gradientTransform: "translate(472.14 3696.08) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#020000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0c0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1b0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#320000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4e0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: -98.5,
    y1: 3233.54,
    x2: -98.5,
    y2: 3301.38,
    gradientTransform: "translate(331.95 3808.62) rotate(-180)",
    xlinkHref: "#linear-gradient-71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: -98.5,
    y1: 3293.6,
    x2: -98.5,
    y2: 3240.52,
    gradientTransform: "translate(-931.93 3512.62) rotate(-157.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#938167"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: -98.5,
    y1: 3246.27,
    x2: -98.5,
    y2: 3288.25,
    gradientTransform: "translate(-926.96 3514.9) rotate(-157.19)",
    xlinkHref: "#linear-gradient-71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: -98.5,
    y1: 3283.43,
    x2: -98.5,
    y2: 3250.59,
    gradientTransform: "translate(-2814.8 930.15) rotate(-98.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d8f8a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 156.37,
    y1: 373.3,
    x2: 156.37,
    y2: 261.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 303.58,
    y1: 373.3,
    x2: 303.58,
    y2: 261.46,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 2436.74,
    y1: 542.49,
    x2: 2436.74,
    y2: 462.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8d8f92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#6c6d6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#545456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#464547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 2429.8,
    x2: 2429.8,
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 2443.68,
    x2: 2443.68,
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 2702.08,
    x2: 2702.08,
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 2702.08,
    x2: 2702.08,
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 2695.14,
    x2: 2695.14,
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 2709.02,
    x2: 2709.02,
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 2569.41,
    y1: 608.37,
    x2: 2569.41,
    y2: 544.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#353436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#171617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-3",
    x1: 2569.41,
    x2: 2569.41,
    y2: 530.05,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-6",
    x1: 2569.41,
    y1: 547.37,
    x2: 2569.41,
    y2: 706.15,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 2569.41,
    x2: 2569.41,
    y2: 567.07,
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 2569.38,
    x2: 2569.38,
    xlinkHref: "#linear-gradient-79"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 2569.41,
    y1: 642.51,
    x2: 2569.41,
    y2: 605.26,
    gradientTransform: "translate(434.41 -935.76) rotate(22.5)",
    xlinkHref: "#linear-gradient-71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 2569.41,
    y1: 637.62,
    x2: 2569.41,
    y2: 611,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-7",
    x1: 1586.42,
    y1: 502.52,
    x2: 1586.42,
    y2: 549.38,
    gradientTransform: "translate(1219.43)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 1981.97,
    y1: 1089.33,
    x2: 1981.97,
    y2: 1107.77,
    gradientTransform: "translate(4808.78 1635.95) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15a29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 1607.38,
    y1: 505.05,
    x2: 1607.38,
    y2: 525.05,
    gradientTransform: "translate(1219.43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be1e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-8",
    x1: 1589.8,
    y1: 479.38,
    x2: 1589.8,
    y2: 549.13,
    gradientTransform: "translate(1219.43)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-9",
    x1: 1597.79,
    y1: 458.4,
    x2: 1597.79,
    y2: 627.11,
    gradientTransform: "translate(1219.43)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-10",
    x1: 1597.79,
    y1: 574.52,
    x2: 1597.79,
    y2: 628.61,
    gradientTransform: "translate(1219.43)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 1781.53,
    y1: 1.17,
    x2: 1781.53,
    y2: 491.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#dfe0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 211.65,
    y1: 217.41,
    x2: 211.65,
    y2: 524.42,
    xlinkHref: "#linear-gradient-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 109.02,
    y1: 563.95,
    x2: 109.02,
    y2: 529.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#747577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#8e8f91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a2a4a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#b1b2b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#b9bbbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#b8babc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#adaeb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9a9b9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#807f81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#5e5c5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#353233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_11_cop",
    x1: 95.53,
    y1: 623.31,
    x2: 95.53,
    y2: 630.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#e3c8af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 31.18,
    y1: 524.27,
    x2: 31.18,
    y2: 632.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 315.84,
    y1: 373.3,
    x2: 315.84,
    y2: 261.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#eeefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#c4c5c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 315.85,
    y1: 362.52,
    x2: 315.85,
    y2: 271.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#d4d6d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e4e5e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#eeefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: -5197.4,
    y1: 500.41,
    x2: -5197.4,
    y2: 488.97,
    gradientTransform: "translate(7938.44 989.12) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be1e2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: -5212.09,
    y1: 488.86,
    x2: -5212.09,
    y2: 500.92,
    gradientTransform: "translate(7967.82 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-103"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: -4539.21,
    x2: -4539.21,
    gradientTransform: "translate(6622.05 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-111"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: -4553.9,
    y1: 488.86,
    x2: -4553.9,
    y2: 500.92,
    gradientTransform: "translate(6651.43 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-103"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: -3881.01,
    x2: -3881.01,
    gradientTransform: "translate(5305.65 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-111"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: -3895.7,
    y1: 488.86,
    x2: -3895.7,
    y2: 500.92,
    gradientTransform: "translate(5335.04 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-103"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: -3222.81,
    x2: -3222.81,
    gradientTransform: "translate(3989.26 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-111"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: -3237.5,
    y1: 488.86,
    x2: -3237.5,
    y2: 500.92,
    gradientTransform: "translate(4018.64 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-103"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 1611.97,
    y1: 666.29,
    x2: 1611.97,
    y2: 605.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 1905.82,
    x2: 1905.82,
    xlinkHref: "#linear-gradient-119"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 2199.68,
    x2: 2199.68,
    xlinkHref: "#linear-gradient-119"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 1758.9,
    y1: 662.69,
    x2: 1758.9,
    y2: 494.97,
    xlinkHref: "#linear-gradient-119"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 2052.75,
    y1: 662.69,
    x2: 2052.75,
    y2: 494.97,
    xlinkHref: "#linear-gradient-119"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: -4625.2,
    y1: 612.6,
    x2: -4625.2,
    gradientTransform: "translate(-2719.38) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-119"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: -4625.2,
    y1: 558.92,
    x2: -4625.2,
    y2: 551.73,
    gradientTransform: "translate(-2719.38) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-119"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: -4625.2,
    x2: -4625.2,
    y2: 494.97,
    gradientTransform: "translate(-2719.38) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-119"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 227.39,
    y1: 435.65,
    x2: 227.39,
    y2: 419.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 207.85,
    y1: 424.06,
    x2: 207.85,
    y2: 431.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 245.43,
    x2: 245.43,
    xlinkHref: "#linear-gradient-128"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 226.64,
    y1: 425.01,
    x2: 226.64,
    y2: 430.15,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 83.55,
    y1: 504.11,
    x2: 83.55,
    y2: 515.29,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-103"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 7.62,
    y1: 360.52,
    x2: 18.41,
    y2: 392.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#8b8f9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9296a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9ea1ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#afb2bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9a9daa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8f867e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#938167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 12.87,
    y1: 264.83,
    x2: 12.87,
    y2: 356.09,
    xlinkHref: "#linear-gradient-132"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "truck3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-178"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-177",
    width: 2825,
    height: 88,
    transform: "translate(2.98 716.07)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M925.77,509.19l-27.97-22.56c-2.73-2.2-6.62-2.2-9.35,0l-27.97,22.56h-33.9c-6.33,0-11.46,5.13-11.46,11.46v11.69h147.25v-11.69c0-6.33-5.13-11.46-11.46-11.46h-25.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M899.88,513.27l19.11-20.59h-50.39l19.11,20.59c3.28,3.54,8.88,3.54,12.17,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "963.04 496.16 830.97 496.16 830.97 484.97 924.6 484.97 963.04 491.94 963.04 496.16"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 847.51,
    y: 484.97,
    width: 77.09,
    height: 11.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-150",
    cx: 893.79,
    cy: 506.37,
    r: 6.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M572.98,500.86c-.57,0-1.15-.02-1.75-.06-1.1-.08-1.93-1.04-1.85-2.14.08-1.1,1.04-1.92,2.14-1.85,9.08.67,14.43-5.16,19.6-10.79,4.33-4.71,8.8-9.59,15.25-9.99,5.42-.33,8.54,3.62,10.82,6.51,1.23,1.56,2.52,3.16,3.26,2.95,2.05-.56,1.68-6.43,1.44-10.32-.33-5.28-.62-9.84,2.97-10.56,3.68-.74,5.1,3.57,6.6,8.12,1.05,3.19,2.64,8,4.52,8h0c1.17-1.1.88-5.98.71-8.9-.32-5.36-.62-10.43,3.1-11.07,3.93-.69,5.33,4.58,6.96,10.66.71,2.65,1.98,7.4,3.09,8.61.6-1.55.6-6.1.61-8.65,0-6.47.02-11.58,3.84-11.61,3.94-.09,5.17,6.12,6.7,13.26.19.9.41,1.91.63,2.87.27-1.24.53-2.59.76-3.76,1.68-8.63,2.82-13.52,6.21-13.33,3.38.16,3.53,4.61,3.77,11.33.11,3.03.3,8.46,1.14,10.07.98-1.34,2-6.02,2.57-8.65,1.23-5.67,2.09-9.21,4.23-10.41.8-.45,1.72-.52,2.59-.22,3.45,1.21,3.73,6.48,4.02,12.07.13,2.57.37,7.26,1.21,8.23.63-.41,1.78-2,2.49-2.98,2.14-2.95,4.8-6.63,8.71-5.72,3.08.72,4.62,2.67,6.12,4.56,3.08,3.89,7.3,9.22,30.61,8.47.99-.03,2.02.83,2.06,1.93.04,1.1-.83,2.03-1.93,2.06-25.34.82-30.27-5.43-33.88-9.99-1.43-1.81-2.25-2.77-3.89-3.15-1.34-.32-3.12,2.17-4.57,4.17-1.94,2.69-4.6,6.38-7.96,3.99-2.48-1.77-2.71-6.22-2.98-11.37-.12-2.35-.33-6.43-1-7.97-.71,1.51-1.46,4.96-1.93,7.17-1.38,6.34-2.68,12.34-6.8,12.02-4.33-.33-4.56-7.04-4.81-14.15-.06-1.6-.13-3.66-.28-5.29-.69,2.33-1.35,5.74-1.77,7.92-1.39,7.16-2.08,10.42-4.78,10.27-2.48-.14-3.14-3.21-4.44-9.31-.55-2.57-1.47-6.88-2.4-9.02-.23,1.76-.24,4.62-.24,6.54,0,6.24-.15,10.16-2.09,11.96-.71.66-1.59.97-2.57.9-3.81-.29-5.24-5.62-6.89-11.79-.58-2.17-1.47-5.51-2.28-7.06-.2,1.52-.03,4.35.08,6.2.29,4.9.57,9.52-1.59,11.82-.81.86-1.88,1.31-3.1,1.31h-.01c-4.76,0-6.65-5.71-8.31-10.74-.49-1.48-1.23-3.74-1.87-4.87-.19,1.38-.02,3.97.09,5.81.36,5.79.81,13-4.37,14.42-3.31.91-5.52-1.87-7.46-4.33-2.02-2.56-4.15-5.21-7.43-5-4.85.3-8.42,4.19-12.56,8.7-5.24,5.71-11.15,12.14-21.09,12.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M546.33,507.04c-.4,0-.81-.01-1.22-.03-1.1-.06-1.95-1-1.89-2.1.06-1.1.95-1.95,2.1-1.89,10.64.56,16.71-7.95,22.58-16.17,5.05-7.07,9.81-13.74,17.27-14.58,6.27-.71,9.98,4.66,12.71,8.57,1.4,2.01,3.13,4.5,4.04,4.17,2.76-1.03,2.08-9.75,1.63-15.53-.59-7.56-1.01-13.02,2.74-14.07,4.13-1.15,5.8,4.35,7.72,10.73,1.31,4.34,3.44,11.63,5.83,11.51.14,0,.2-.03.29-.14,1.42-1.59.89-8.67.53-13.35-.58-7.73-1.04-13.84,2.87-14.8,4.38-1.08,6.08,5.68,8.21,14.23.99,3.98,2.79,11.19,4.3,12.62.91-1.91.74-8.9.63-13.19-.23-9.32-.38-15.48,3.72-15.67,4.15-.23,5.7,6.66,7.98,17.85.36,1.76.78,3.83,1.2,5.61.36-2.17.72-4.8,1.01-7,1.68-12.5,2.71-18.5,6.43-18.42,3.65.08,3.94,5.4,4.47,15.06.26,4.64.72,13.05,2.01,15,1.28-1.69,2.35-8.71,3.01-13.02,1.26-8.27,2.09-13.02,4.55-14.45.83-.48,1.79-.56,2.7-.21,3.77,1.44,4.21,7.91,4.78,16.11.3,4.33.74,10.81,1.98,12.23.79-.68,2.12-3.12,2.94-4.63,2.42-4.47,5.43-10.03,10.2-7.94,2,.87,3.34,2.67,5.03,4.94,4.23,5.67,11.31,15.17,37.16,16.84,1.1.07,1.94,1.02,1.87,2.12-.07,1.1-1.02,1.93-2.12,1.87-27.69-1.79-35.46-12.21-40.1-18.44-1.34-1.8-2.4-3.22-3.42-3.67-1.41-.6-3.63,3.48-5.09,6.18-1.83,3.38-3.4,6.29-5.83,6.78-.74.15-1.85.13-3-.8-2.52-2.04-3.04-7.1-3.59-15.2-.25-3.7-.71-10.24-1.8-12.17-.91,1.95-1.73,7.33-2.3,11.05-1.44,9.43-2.61,16.89-7.17,16.62-4.76-.26-5.21-8.52-5.79-18.98-.16-2.89-.37-6.8-.76-9.32-.88,3.24-1.67,9.09-2.19,12.98-1.38,10.29-1.99,14.11-4.88,14.04-2.58-.09-3.3-3.04-5.2-12.38-.83-4.05-2.26-11.06-3.6-13.76-.4,2.36-.28,7.24-.2,10.69.22,8.77.23,14.27-2.06,16.49-.71.69-1.62,1.03-2.58.98-4.28-.23-5.99-7.12-8.16-15.83-.86-3.44-2.22-8.91-3.37-10.8-.46,1.97-.08,6.96.15,10.1.52,6.92,1.01,13.45-1.54,16.31-.81.91-1.89,1.42-3.12,1.47-5.45.16-7.65-7.19-9.81-14.35-.77-2.57-1.89-6.26-2.8-7.62-.45,1.76-.09,6.34.15,9.5.67,8.61,1.36,17.51-4.23,19.58-3.81,1.41-6.31-2.17-8.72-5.64-2.98-4.29-5.37-7.28-8.98-6.88-5.68.64-9.95,6.61-14.46,12.93-5.99,8.39-12.76,17.87-24.82,17.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 1269.58,
    y: 473.87,
    width: 1554.5,
    height: 92.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M734.06,457.44v32.86h372.22c31.92,0,63.73,3.82,94.74,11.38l116.64,28.43c29.5,7.19,59.75,10.82,90.11,10.82h1416.3v-83.49H734.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M734.06,457.44v32.86h372.22c31.92,0,63.73,3.82,94.74,11.38l116.64,28.43c29.5,7.19,59.75,10.82,90.11,10.82h1416.3v-83.49H734.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 1265.42,
    y: 583.16,
    width: 97.35,
    height: 11.6,
    transform: "translate(-31.57 1101.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 1256.05,
    y: 510.52,
    width: 23.76,
    height: 163.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1233.09,683.19h69.68v3.54c0,2.51-2.04,4.55-4.55,4.55h-60.58c-2.51,0-4.55-2.04-4.55-4.55v-3.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1260.34,655.93l-15.72,27.23h46.63l-15.72-27.23c-3.38-5.85-11.82-5.85-15.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M1273.18,662.9c0,2.9-2.35,5.25-5.25,5.25s-5.25-2.35-5.25-5.25,2.35-5.25,5.25-5.25,5.25,2.35,5.25,5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1259.49,494.97h16.9c7.16,0,12.98,5.82,12.98,12.98v130.64h-42.86v-130.64c0-7.16,5.82-12.98,12.98-12.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M1263.47,512.29c0,3.31-2.68,6-6,6s-6-2.68-6-6,2.68-6,6-6,6,2.68,6,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M1281.57,530.39c0,3.31-2.68,6-6,6s-6-2.68-6-6,2.68-6,6-6,6,2.68,6,6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 473.08,
    y: 611.89,
    width: 516.08,
    height: 8.47,
    transform: "translate(84.35 -88.03) rotate(7.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 1128.66,
    y: 578.93,
    width: 24.71,
    height: 5.1,
    transform: "translate(559.54 1722.49) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 1128.66,
    y: 580.25,
    width: 24.71,
    height: 2.45,
    transform: "translate(559.54 1722.49) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 1122.25,
    y: 587.32,
    width: 26.98,
    height: 4.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 1122.25,
    y: 571.5,
    width: 26.98,
    height: 4.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M513.94,362.33c4.02,6.3,6.17,13.77,6.17,21.43v34.67c0,7.66-2.15,15.13-6.17,21.43l-6,9.4v-96.32l6,9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M513.94,362.33c4.02,6.3,6.17,13.77,6.17,21.43v34.67c0,7.66-2.15,15.13-6.17,21.43l-6,9.4v-96.32l6,9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M504.68,458.35h0c3.04,0,5.5-2.46,5.5-5.5v-103.5c0-3.04-2.46-5.5-5.5-5.5h0v114.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M447.81,315.09l4.39-6.29h48.83l4.39,6.29c1.64,2.35,2.54,5.28,2.54,8.3v155.42c0,3.01-.89,5.94-2.54,8.3l-4.39,6.29h-48.83l-4.39-6.29c-1.64-2.35-2.54-5.28-2.54-8.3v-155.42c0-3.02.89-5.94,2.54-8.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 452.19,
    y: 308.8,
    width: 48.83,
    height: 184.59,
    transform: "translate(953.21 802.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 452.19,
    y: 492.08,
    width: 5.86,
    height: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 452.19,
    y: 489.31,
    width: 5.86,
    height: 1.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 452.19,
    y: 486,
    width: 5.86,
    height: 1.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 452.19,
    y: 481.97,
    width: 5.86,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 452.19,
    y: 477.26,
    width: 5.86,
    height: 2.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 452.19,
    y: 472.09,
    width: 5.86,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 452.19,
    y: 466.3,
    width: 5.86,
    height: 3.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 452.19,
    y: 460.14,
    width: 5.86,
    height: 3.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 452.19,
    y: 453.37,
    width: 5.86,
    height: 3.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 452.19,
    y: 446.29,
    width: 5.86,
    height: 4.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 452.19,
    y: 438.78,
    width: 5.86,
    height: 4.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 452.19,
    y: 430.98,
    width: 5.86,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 452.19,
    y: 422.97,
    width: 5.86,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 452.19,
    y: 414.74,
    width: 5.86,
    height: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 452.19,
    y: 406.52,
    width: 5.86,
    height: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 452.19,
    y: 308.8,
    width: 5.86,
    height: 1.31,
    transform: "translate(910.24 618.91) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 452.19,
    y: 311.18,
    width: 5.86,
    height: 1.71,
    transform: "translate(910.24 624.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 452.19,
    y: 314.23,
    width: 5.86,
    height: 1.97,
    transform: "translate(910.24 630.42) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 452.19,
    y: 317.85,
    width: 5.86,
    height: 2.38,
    transform: "translate(910.24 638.08) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 452.19,
    y: 322.14,
    width: 5.86,
    height: 2.79,
    transform: "translate(910.24 647.07) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 452.19,
    y: 327.05,
    width: 5.86,
    height: 3.05,
    transform: "translate(910.24 657.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 452.19,
    y: 332.43,
    width: 5.86,
    height: 3.46,
    transform: "translate(910.24 668.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 452.19,
    y: 338.38,
    width: 5.86,
    height: 3.67,
    transform: "translate(910.24 680.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 452.19,
    y: 344.94,
    width: 5.86,
    height: 3.88,
    transform: "translate(910.24 693.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 452.19,
    y: 351.72,
    width: 5.86,
    height: 4.19,
    transform: "translate(910.24 707.63) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 452.19,
    y: 359.07,
    width: 5.86,
    height: 4.34,
    transform: "translate(910.24 722.49) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 452.19,
    y: 366.58,
    width: 5.86,
    height: 4.63,
    transform: "translate(910.24 737.8) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 452.19,
    y: 374.6,
    width: 5.86,
    height: 4.63,
    transform: "translate(910.24 753.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 452.19,
    y: 382.61,
    width: 5.86,
    height: 4.83,
    transform: "translate(910.24 770.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 452.19,
    y: 390.84,
    width: 5.86,
    height: 4.83,
    transform: "translate(910.24 786.51) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 452.19,
    y: 398.72,
    width: 5.86,
    height: 4.76,
    transform: "translate(910.24 802.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 495.16,
    y: 492.08,
    width: 5.86,
    height: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 495.16,
    y: 489.31,
    width: 5.86,
    height: 1.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 495.16,
    y: 486,
    width: 5.86,
    height: 1.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 495.16,
    y: 481.97,
    width: 5.86,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 495.16,
    y: 477.26,
    width: 5.86,
    height: 2.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 495.16,
    y: 472.09,
    width: 5.86,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 495.16,
    y: 466.3,
    width: 5.86,
    height: 3.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 495.16,
    y: 460.14,
    width: 5.86,
    height: 3.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 495.16,
    y: 453.37,
    width: 5.86,
    height: 3.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 495.16,
    y: 446.29,
    width: 5.86,
    height: 4.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 495.16,
    y: 438.78,
    width: 5.86,
    height: 4.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 495.16,
    y: 430.98,
    width: 5.86,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 495.16,
    y: 422.97,
    width: 5.86,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 495.16,
    y: 414.74,
    width: 5.86,
    height: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 495.16,
    y: 406.52,
    width: 5.86,
    height: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 495.16,
    y: 308.8,
    width: 5.86,
    height: 1.31,
    transform: "translate(996.18 618.91) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 495.16,
    y: 311.18,
    width: 5.86,
    height: 1.71,
    transform: "translate(996.18 624.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 495.16,
    y: 314.23,
    width: 5.86,
    height: 1.97,
    transform: "translate(996.18 630.42) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 495.16,
    y: 317.85,
    width: 5.86,
    height: 2.38,
    transform: "translate(996.18 638.08) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 495.16,
    y: 322.14,
    width: 5.86,
    height: 2.79,
    transform: "translate(996.18 647.07) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 495.16,
    y: 327.05,
    width: 5.86,
    height: 3.05,
    transform: "translate(996.18 657.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 495.16,
    y: 332.43,
    width: 5.86,
    height: 3.46,
    transform: "translate(996.18 668.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 495.16,
    y: 338.38,
    width: 5.86,
    height: 3.67,
    transform: "translate(996.18 680.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 495.16,
    y: 344.94,
    width: 5.86,
    height: 3.88,
    transform: "translate(996.18 693.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 495.16,
    y: 351.72,
    width: 5.86,
    height: 4.19,
    transform: "translate(996.18 707.63) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 495.16,
    y: 359.07,
    width: 5.86,
    height: 4.34,
    transform: "translate(996.18 722.49) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 495.16,
    y: 366.58,
    width: 5.86,
    height: 4.63,
    transform: "translate(996.18 737.8) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 495.16,
    y: 374.6,
    width: 5.86,
    height: 4.63,
    transform: "translate(996.18 753.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 495.16,
    y: 382.61,
    width: 5.86,
    height: 4.83,
    transform: "translate(996.18 770.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 495.16,
    y: 390.84,
    width: 5.86,
    height: 4.83,
    transform: "translate(996.18 786.51) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 495.16,
    y: 398.72,
    width: 5.86,
    height: 4.76,
    transform: "translate(996.18 802.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 457.02,
    y: 308.8,
    width: 39.17,
    height: 184.59,
    transform: "translate(953.21 802.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M488.67,326.29l.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.11-.15.25-.24.39-.24h1.42l-1.7,2.35c-.28.39-.28,1.09,0,1.48l1.24,1.72h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-2.06,2.86,1.7,2.37.07-.12.69,1.17.13.18v.02s0,.02,0,.02l-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33h0s.82,1.39.82,1.39l-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l2.2,3.72-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33h0l.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l2.2,3.72-.02.04.02.03-.21.29-.61,1.03-.06-.1-1.71,2.38,1.77,2.46h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.7,2.36h-1.42c-.14,0-.28-.08-.39-.24l-1.24-1.73-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.31-1.82c.26-.36.28-1.01.04-1.41l-1.36-2.3-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39,2.2-3.72c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-2.2-3.72.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.35-2.28c.24-.4.22-1.05-.04-1.41l-1.3-1.81-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M479.22,326.29l.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.11-.15.25-.24.39-.24h1.42l-1.7,2.35c-.28.39-.28,1.09,0,1.48l1.24,1.72h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-2.06,2.86,1.7,2.37.07-.12.69,1.17.13.18v.02s0,.02,0,.02l-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33h0s.82,1.39.82,1.39l-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l2.2,3.72-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33h0l.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l2.2,3.72-.02.04.02.03-.21.29-.61,1.03-.06-.1-1.71,2.38,1.77,2.46h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.7,2.36h-1.42c-.14,0-.28-.08-.39-.24l-1.24-1.73-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.31-1.82c.26-.36.28-1.01.04-1.41l-1.36-2.3-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39,2.2-3.72c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-2.2-3.72.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.35-2.28c.24-.4.22-1.05-.04-1.41l-1.3-1.81-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M469.76,326.29l.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.11-.15.25-.24.39-.24h1.42l-1.7,2.35c-.28.39-.28,1.09,0,1.48l1.24,1.72h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-2.06,2.86,1.7,2.37.07-.12.69,1.17.13.18v.02s0,.02,0,.02l-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33h0s.82,1.39.82,1.39l-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l2.2,3.72-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33h0l.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l2.2,3.72-.02.04.02.03-.21.29-.61,1.03-.06-.1-1.71,2.38,1.77,2.46h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.7,2.36h-1.42c-.14,0-.28-.08-.39-.24l-1.24-1.73-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.31-1.82c.26-.36.28-1.01.04-1.41l-1.36-2.3-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39,2.2-3.72c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-2.2-3.72.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.35-2.28c.24-.4.22-1.05-.04-1.41l-1.3-1.81-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M460.31,326.29l.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.11-.15.25-.24.39-.24h1.42l-1.7,2.35c-.28.39-.28,1.09,0,1.48l1.24,1.72h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-2.06,2.86,1.7,2.37.07-.12.69,1.17.13.18v.02s0,.02,0,.02l-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33h0s.82,1.39.82,1.39l-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l2.2,3.72-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33h0l.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l2.2,3.72-.02.04.02.03-.21.29-.61,1.03-.06-.1-1.71,2.38,1.77,2.46h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.7,2.36h-1.42c-.14,0-.28-.08-.39-.24l-1.24-1.73-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.31-1.82c.26-.36.28-1.01.04-1.41l-1.36-2.3-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39,2.2-3.72c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-2.2-3.72.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.35-2.28c.24-.4.22-1.05-.04-1.41l-1.3-1.81-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M689.99,518.59l-27.09-21.79h-277.59v-48.27c0-13.61-11.03-24.64-24.64-24.64H59.14v167.59h61.44c14.98,0,29.61,3,42.31,8.66,16.52,7.38,35.51,11.27,54.92,11.27h99.68c8.66,0,17.34-.82,25.76-2.37,7.53,6.08,15.39,10.05,23.09,10.05h166.1c13.48,0,23.04-3.25,34.11-7.01,13.11-4.46,81.45-7.26,81.45-7.26h223.6c4.84,0,9.69-1.17,13.69-3.89,3.73-2.53,8.13-3.88,12.63-3.88h232.21v-45.15c0-2.01-1.09-3.85-2.84-4.83h0c-33.67-18.68-98.95-28.49-137.46-28.49h-299.83ZM317.49,592.12h-99.68c-14.98,0-29.61-3-42.31-8.67-5.98-2.67-12.3-4.87-18.83-6.61h158.75c3.36,4.97,7.05,10.06,10.98,14.91-2.96.24-5.94.36-8.91.36ZM340.96,589.58c-3.45-3.87-6.88-8.18-10.22-12.73h50.23c-3.18.84-6.31,1.77-9.35,2.83l-19.12,6.66c-3.72,1.3-7.59,2.37-11.55,3.23ZM562.53,600.26c-10.84,3.68-18.68,6.35-30.09,6.35h-166.1c-2.12,0-4.37-.59-6.7-1.63,1.08-.34,2.17-.67,3.23-1.04l19.12-6.67c10.84-3.78,22.95-5.78,35.02-5.78h112.83l48.31,3.77c-5.91,1.7-10.98,3.42-15.62,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M689.99,518.59l-27.09-21.79h-277.59v-48.27c0-13.61-11.03-24.64-24.64-24.64H59.14v167.59h61.44c14.98,0,29.61,3,42.31,8.66,16.52,7.38,35.51,11.27,54.92,11.27h99.68c8.66,0,17.34-.82,25.76-2.37,7.53,6.08,15.39,10.05,23.09,10.05h166.1c13.48,0,23.04-3.25,34.11-7.01,13.11-4.46,81.45-7.26,81.45-7.26h223.6c4.84,0,9.69-1.17,13.69-3.89,3.73-2.53,8.13-3.88,12.63-3.88h232.21v-45.15c0-2.01-1.09-3.85-2.84-4.83h0c-33.67-18.68-98.95-28.49-137.46-28.49h-299.83ZM317.49,592.12h-99.68c-14.98,0-29.61-3-42.31-8.67-5.98-2.67-12.3-4.87-18.83-6.61h158.75c3.36,4.97,7.05,10.06,10.98,14.91-2.96.24-5.94.36-8.91.36ZM340.96,589.58c-3.45-3.87-6.88-8.18-10.22-12.73h50.23c-3.18.84-6.31,1.77-9.35,2.83l-19.12,6.66c-3.72,1.3-7.59,2.37-11.55,3.23ZM562.53,600.26c-10.84,3.68-18.68,6.35-30.09,6.35h-166.1c-2.12,0-4.37-.59-6.7-1.63,1.08-.34,2.17-.67,3.23-1.04l19.12-6.67c10.84-3.78,22.95-5.78,35.02-5.78h112.83l48.31,3.77c-5.91,1.7-10.98,3.42-15.62,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M261.18,533.19c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM261.18,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M353.48,626.8v-4.71h-5.8c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.82l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.72,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.81c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.72-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM261.18,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M261.18,541.72c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM261.18,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M311.06,632.33c-1.08,1.93-2.53,3.14-4.13,3.14-3.34,0-6.05-5.16-6.05-11.52s2.71-11.52,6.05-11.52c1.57,0,2.99,1.17,4.07,3.04-1.32-7.68-4.36-14.76-8.73-20.84.61,2.14.44,4.02-.7,5.16-2.36,2.36-7.93.64-12.43-3.86-4.5-4.5-6.23-10.06-3.86-12.43,1.12-1.12,2.96-1.29,5.06-.72-6.11-4.32-13.22-7.3-20.92-8.56,1.93,1.08,3.13,2.53,3.13,4.13,0,3.34-5.16,6.05-11.52,6.05s-11.52-2.71-11.52-6.05c0-1.57,1.17-2.99,3.04-4.07-7.68,1.32-14.76,4.36-20.84,8.73,2.14-.61,4.02-.44,5.16.7,2.36,2.36.63,7.93-3.86,12.43-4.5,4.5-10.06,6.23-12.43,3.86-1.12-1.12-1.29-2.96-.72-5.06-4.32,6.11-7.3,13.22-8.56,20.92,1.08-1.93,2.53-3.14,4.13-3.14,3.34,0,6.05,5.16,6.05,11.52s-2.71,11.52-6.05,11.52c-1.57,0-2.99-1.17-4.07-3.04,1.32,7.68,4.36,14.76,8.73,20.84-.61-2.14-.44-4.02.7-5.16,2.37-2.36,7.93-.64,12.43,3.86,4.5,4.5,6.23,10.06,3.86,12.43-1.12,1.12-2.96,1.29-5.06.72,6.11,4.32,13.22,7.3,20.92,8.56-1.93-1.08-3.14-2.53-3.14-4.13,0-3.34,5.16-6.05,11.52-6.05s11.52,2.71,11.52,6.05c0,1.58-1.17,2.99-3.04,4.07,7.68-1.32,14.76-4.36,20.84-8.73-2.14.61-4.02.44-5.16-.7-2.36-2.37-.63-7.93,3.86-12.43,4.5-4.5,10.06-6.23,12.43-3.86,1.12,1.12,1.29,2.96.72,5.06,4.32-6.11,7.3-13.22,8.56-20.92Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 261.18,
    cy: 624.09,
    r: 31.07,
    transform: "translate(-410.23 707.19) rotate(-74.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M261.18,573.43c-27.98,0-50.66,22.68-50.66,50.66s22.68,50.66,50.66,50.66,50.66-22.68,50.66-50.66-22.68-50.66-50.66-50.66ZM261.18,671.7c-26.29,0-47.61-21.31-47.61-47.61s21.31-47.61,47.61-47.61,47.61,21.31,47.61,47.61-21.31,47.61-47.61,47.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M261.18,566.61c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM261.18,673.97c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M311.06,632.33c-1.08,1.93-2.53,3.14-4.13,3.14-3.34,0-6.05-5.16-6.05-11.52s2.71-11.52,6.05-11.52c1.57,0,2.99,1.17,4.07,3.04-1.32-7.68-4.36-14.76-8.73-20.84.61,2.14.44,4.02-.7,5.16-2.36,2.36-7.93.64-12.43-3.86-4.5-4.5-6.23-10.06-3.86-12.43,1.12-1.12,2.96-1.29,5.06-.72-6.11-4.32-13.22-7.3-20.92-8.56,1.93,1.08,3.13,2.53,3.13,4.13,0,3.34-5.16,6.05-11.52,6.05s-11.52-2.71-11.52-6.05c0-1.57,1.17-2.99,3.04-4.07-7.68,1.32-14.76,4.36-20.84,8.73,2.14-.61,4.02-.44,5.16.7,2.36,2.36.63,7.93-3.86,12.43-4.5,4.5-10.06,6.23-12.43,3.86-1.12-1.12-1.29-2.96-.72-5.06-4.32,6.11-7.3,13.22-8.56,20.92,1.08-1.93,2.53-3.14,4.13-3.14,3.34,0,6.05,5.16,6.05,11.52s-2.71,11.52-6.05,11.52c-1.57,0-2.99-1.17-4.07-3.04,1.32,7.68,4.36,14.76,8.73,20.84-.61-2.14-.44-4.02.7-5.16,2.37-2.36,7.93-.64,12.43,3.86,4.5,4.5,6.23,10.06,3.86,12.43-1.12,1.12-2.96,1.29-5.06.72,6.11,4.32,13.22,7.3,20.92,8.56-1.93-1.08-3.14-2.53-3.14-4.13,0-3.34,5.16-6.05,11.52-6.05s11.52,2.71,11.52,6.05c0,1.58-1.17,2.99-3.04,4.07,7.68-1.32,14.76-4.36,20.84-8.73-2.14.61-4.02.44-5.16-.7-2.36-2.37-.63-7.93,3.86-12.43,4.5-4.5,10.06-6.23,12.43-3.86,1.12,1.12,1.29,2.96.72,5.06,4.32-6.11,7.3-13.22,8.56-20.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M261.18,572c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM261.18,673.04c-27.04,0-48.95-21.92-48.95-48.95s21.92-48.95,48.95-48.95,48.95,21.92,48.95,48.95-21.92,48.95-48.95,48.95Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-124",
    cx: 261.18,
    cy: 624.09,
    r: 18.8,
    transform: "translate(-268.76 203.54) rotate(-28.86)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "263.65 645.21 259.48 645.21 257.4 648.82 259.48 652.44 263.65 652.44 265.74 648.82 263.65 645.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M263.61,648.82c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "277.86 637.27 274.91 640.23 275.99 644.25 280.02 645.33 282.97 642.38 281.89 638.35 277.86 637.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M280.39,639.86c.8.8.8,2.1,0,2.89-.8.8-2.09.8-2.89,0s-.8-2.1,0-2.89c.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "282.3 621.62 282.3 625.79 285.91 627.87 289.53 625.79 289.53 621.62 285.91 619.53 282.3 621.62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-150",
    cx: 285.91,
    cy: 623.7,
    r: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "274.36 607.41 277.31 610.36 281.34 609.28 282.42 605.25 279.47 602.3 275.44 603.38 274.36 607.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M276.95,604.88c.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89s-2.1.8-2.89,0-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "258.71 602.97 262.88 602.97 264.96 599.36 262.88 595.74 258.71 595.74 256.62 599.36 258.71 602.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M258.74,599.36c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "244.5 610.91 247.45 607.96 246.37 603.93 242.34 602.85 239.39 605.8 240.47 609.83 244.5 610.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M241.97,608.32c-.8-.8-.8-2.09,0-2.89.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "240.06 626.56 240.06 622.39 236.45 620.31 232.83 622.39 232.83 626.56 236.45 628.65 240.06 626.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M236.45,626.53c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "247.99 640.77 245.04 637.82 241.02 638.9 239.94 642.93 242.89 645.88 246.92 644.8 247.99 640.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M245.41,643.3c-.8.8-2.1.8-2.89,0s-.8-2.09,0-2.89c.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-125",
    cx: 261.18,
    cy: 624.09,
    r: 13.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 533.29,
    y: 532.63,
    width: 190.9,
    height: 102.68,
    rx: 3.98,
    ry: 3.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 545.22,
    y: 622.75,
    width: 30.55,
    height: 18.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 555.98,
    y: 529.02,
    width: 9.04,
    height: 110.64,
    rx: 3.62,
    ry: 3.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M560.5,639.66h0c-1.6,0-2.89-1.3-2.89-2.89v-104.85c0-1.6,1.3-2.89,2.89-2.89h0c1.6,0,2.89,1.3,2.89,2.89v104.85c0,1.6-1.3,2.89-2.89,2.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 613.46,
    y: 622.75,
    width: 30.55,
    height: 18.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 624.22,
    y: 529.02,
    width: 9.04,
    height: 110.64,
    rx: 3.62,
    ry: 3.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M628.74,639.66h0c-1.6,0-2.89-1.3-2.89-2.89v-104.85c0-1.6,1.3-2.89,2.89-2.89h0c1.6,0,2.89,1.3,2.89,2.89v104.85c0,1.6-1.3,2.89-2.89,2.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 681.71,
    y: 622.75,
    width: 30.55,
    height: 18.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 692.47,
    y: 529.02,
    width: 9.04,
    height: 110.64,
    rx: 3.62,
    ry: 3.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M696.98,639.66h0c-1.6,0-2.89-1.3-2.89-2.89v-104.85c0-1.6,1.3-2.89,2.89-2.89h0c1.6,0,2.89,1.3,2.89,2.89v104.85c0,1.6-1.3,2.89-2.89,2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M648.87,532.47h24.4v6.06c0,5.63-4.57,10.2-10.2,10.2h-4.01c-5.63,0-10.2-4.57-10.2-10.2v-6.06h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-149",
    cx: 661.07,
    cy: 532.47,
    rx: 12.2,
    ry: 8.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M671.55,530.82c0,3.8-4.69,6.87-10.48,6.87s-10.48-3.08-10.48-6.87,4.69-6.87,10.48-6.87,10.48,3.08,10.48,6.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M1122.22,598.46l-5.55-10.65c-2.55-4.89-8.58-6.79-13.47-4.24h0c-4.89,2.55-6.79,8.59-4.24,13.48l3.27,6.27h-108.53v-.47h-17.75v.47h-108.53l3.27-6.27c2.55-4.89.65-10.92-4.24-13.48h0c-4.89-2.55-10.93-.65-13.48,4.24l-5.55,10.64c-2.55,4.89-.65,10.92,4.24,13.47h0c4.41,2.3,9.72.96,12.6-2.91h25.15v2.85h9.89v2.85h15.67v2.85h17.31v2.85h22.27v2.85h21.4v1.86h17.75v-1.86h21.4v-2.85h22.27v-2.85h17.32v-2.85h15.66v-2.85h9.89v-2.85h25.16c2.88,3.87,8.19,5.21,12.6,2.91h0c4.89-2.55,6.79-8.59,4.24-13.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-152",
    cx: 985.07,
    cy: 624.09,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M1128.96,670.56c-6.08-2.73-23.11-5.04-24.13-26.15-.48-9.85-.67-45.37-.81-56.86h-3.32v57.23c0,11.72,1.6,14.72,6.78,23.52,3.47,5.88,10.51,9.59,17.74,6.9l3.55-1.32c1.69-.63,1.82-2.59.19-3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M1100.7,624.09h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M1094.46,624.09h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M985.06,533.19c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM985.06,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1077.36,626.8v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.82l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.35-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.81c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.82.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.51-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM985.06,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M985.06,541.72c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM985.06,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M985.06,566.61c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM985.06,673.97c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M985.06,572c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM985.06,672.19c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M985.03,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM952.26,591.54c4.01-4.01,8.98-5.56,11.09-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM944.22,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM963.53,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08s7.07-.57,11.08,3.45c4.01,4.01,5.56,8.98,3.45,11.09ZM984.9,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM985.16,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1006.53,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1017.8,656.71c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08,8.98-5.56,11.08-3.45c2.11,2.11.57,7.07-3.45,11.08ZM1025.84,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M1035.07,617.52c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM959.9,599.18c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM984.9,588.71c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1021.06,602.44c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M949.86,603.28c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM984.9,577.91c5.68,0,10.28,2.42,10.28,5.4s-4.6,5.4-10.28,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M985.03,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM952.26,591.54c4.01-4.01,8.98-5.56,11.09-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM944.22,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM963.53,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08s7.07-.57,11.08,3.45c4.01,4.01,5.56,8.98,3.45,11.09ZM984.9,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM985.16,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1006.53,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1017.8,656.71c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08,8.98-5.56,11.08-3.45c2.11,2.11.57,7.07-3.45,11.08ZM1025.84,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "987.53 645.21 983.36 645.21 981.28 648.82 983.36 652.44 987.53 652.44 989.62 648.82 987.53 645.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M987.49,648.82c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "1001.74 637.27 998.79 640.23 999.87 644.25 1003.9 645.33 1006.85 642.38 1005.77 638.35 1001.74 637.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M1004.27,639.86c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89c.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "1006.18 621.62 1006.18 625.79 1009.79 627.87 1013.41 625.79 1013.41 621.62 1009.79 619.53 1006.18 621.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M1009.79,621.66c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "998.24 607.41 1001.19 610.36 1005.22 609.28 1006.3 605.25 1003.35 602.3 999.32 603.38 998.24 607.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M1000.83,604.88c.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "982.59 602.97 986.76 602.97 988.84 599.36 986.76 595.74 982.59 595.74 980.5 599.36 982.59 602.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M982.62,599.36c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "968.38 610.91 971.33 607.96 970.25 603.93 966.22 602.85 963.27 605.8 964.35 609.83 968.38 610.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M965.85,608.32c-.8-.8-.8-2.09,0-2.89.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.09.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "963.94 626.56 963.94 622.39 960.33 620.31 956.71 622.39 956.71 626.56 960.33 628.65 963.94 626.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M960.33,626.53c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "971.87 640.77 968.92 637.82 964.89 638.9 963.82 642.93 966.77 645.88 970.79 644.8 971.87 640.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M969.29,643.3c-.8.8-2.1.8-2.89,0s-.8-2.09,0-2.89c.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-135",
    cx: 985.06,
    cy: 624.09,
    r: 18.8,
    transform: "translate(-163.85 424.47) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-136",
    cx: 985.06,
    cy: 624.09,
    r: 13.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M1090.4,571.72c5.24,10.56,8.91,22.04,10.71,34.12.32,2.15,2.12,3.77,4.29,3.77h14.06v-47.75h-23c-5.07,0-8.31,5.32-6.05,9.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1118.53,587.56h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.71-2.56-5.71-5.72v-7.36c0-3.16,2.56-5.72,5.71-5.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 1119.17,
    y: 588.96,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1119.28,
    y: 589.28,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1117.98,588.96h.21c.29,0,.52.23.52.52v14.94c0,.29-.23.52-.52.52h-.21c-.29,0-.52-.23-.52-.52v-14.94c0-.29.23-.52.52-.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1117.57,
    y: 589.28,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 1115.75,
    y: 588.96,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1115.86,
    y: 589.28,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1118.53,565.13h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.71-2.56-5.71-5.71v-7.36c0-3.16,2.56-5.72,5.71-5.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M1119.69,566.54h.21c.29,0,.52.23.52.52v14.94c0,.29-.23.52-.52.52h-.21c-.29,0-.52-.23-.52-.52v-14.94c0-.29.23-.52.52-.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 1119.28,
    y: 566.85,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 1117.46,
    y: 566.54,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 1117.57,
    y: 566.85,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 1115.75,
    y: 566.54,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 1115.86,
    y: 566.85,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M1095.35,555.37c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M442.82,389.25v91.35h70.94v-91.35h-70.94ZM492.6,446.54c0,5.57-6.4,10.09-14.3,10.09s-14.3-4.52-14.3-10.09v-33.67c0-5.57,6.4-10.09,14.3-10.09s14.3,4.52,14.3,10.09v33.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M442.82,378.02v114.26h70.94v-114.26h-70.94ZM492.6,449.67c0,6.97-6.4,12.61-14.3,12.61s-14.3-5.65-14.3-12.61v-42.11c0-6.97,6.4-12.62,14.3-12.62s14.3,5.65,14.3,12.62v42.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M442.82,372.54v129.54h70.94v-129.54h-70.94ZM492.6,453.78c0,7.9-6.4,14.3-14.3,14.3s-14.3-6.4-14.3-14.3v-47.74c0-7.9,6.4-14.3,14.3-14.3s14.3,6.4,14.3,14.3v47.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M459.15,492.68c0,3.21-2.6,5.82-5.82,5.82s-5.82-2.6-5.82-5.82,2.6-5.82,5.82-5.82,5.82,2.6,5.82,5.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-172",
    cx: 453.33,
    cy: 492.68,
    r: 4.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M509.08,492.68c0,3.21-2.6,5.82-5.82,5.82s-5.82-2.6-5.82-5.82,2.6-5.82,5.82-5.82,5.82,2.6,5.82,5.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-172",
    cx: 503.26,
    cy: 492.68,
    r: 4.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M384.61,283.69h36.12v181.89c0,8.58-6.96,15.54-15.54,15.54h-20.58v-197.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M429.94,525.92h-24.76v-33.44c0-4.01-3.25-7.26-7.26-7.26s-7.26,3.25-7.26,7.26v70.4c0,4.26,3.45,7.71,7.71,7.71h31.58c4.26,0,7.71-3.45,7.71-7.71v-29.25c0-4.26-3.45-7.71-7.71-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M414.66,558.46h24.76v33.44c0,4.01,3.25,7.26,7.26,7.26s7.26-3.25,7.26-7.26v-70.4c0-4.26-3.45-7.71-7.71-7.71h-31.58c-4.26,0-7.71,3.45-7.71,7.71v29.25c0,4.26,3.45,7.71,7.71,7.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-129",
    cx: 430.45,
    cy: 541.69,
    r: 34.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-133",
    cx: 430.45,
    cy: 541.69,
    r: 27.78,
    transform: "translate(-176.9 210.27) rotate(-22.91)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-134",
    cx: 430.45,
    cy: 541.69,
    r: 21.33,
    transform: "translate(-176.35 209.26) rotate(-22.81)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-132",
    cx: 430.45,
    cy: 541.69,
    r: 17.19,
    transform: "translate(-169.23 886.78) rotate(-81.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M248.49,316.24c1.74-2.14,2.66-4.94,2.3-7.88l-2.46-19.75c-.71-5.71-5.96-9.8-11.67-9.09l-.34.04c-5.71.71-9.8,5.96-9.09,11.67l2.46,19.75c.37,2.96,1.98,5.47,4.22,7.12-4.18,2.64-7.24,7.01-8,12.25l-8.48,58.55c-1.38,9.51,5.27,18.41,14.78,19.79,9.51,1.38,18.41-5.27,19.79-14.78l8.48-58.55c1.24-8.54-4.01-16.58-11.99-19.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M84.88,356.38c-.2,1.92,1.18,3.66,3.04,4.16l23.56,6.41-2.76,10.14c-.38,1.39-1.81,2.21-3.2,1.83h0c-.95-.26-1.92.3-2.18,1.25l-14.33,52.66,21.4,5.82,14.33-52.66c.26-.95-.3-1.92-1.25-2.18h0c-1.39-.38-2.21-1.81-1.83-3.2l2.76-10.14,23.56,6.41c1.86.51,3.93-.3,4.73-2.05,1.02-2.24-.23-4.75-2.5-5.36l-60.46-16.45c-2.27-.62-4.61.92-4.87,3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M122.51,259.98h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.59c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 271.8,
    y: 259.98,
    width: 63.55,
    height: 113.32,
    rx: 11.09,
    ry: 11.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M271.8,345.32v16.89c0,6.13,4.97,11.09,11.09,11.09h41.37c6.13,0,11.09-4.97,11.09-11.09v-16.89h-63.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M135.02,356.95l-5.79,8.81c-3.08,4.7-8.33,7.53-13.95,7.53h-39.42c-1.09,8.59-1.8,17.08-2.14,25.56-.47,11.93,10.7,20.94,22.24,17.9l127.56-33.59c9.13-2.4,15.5-10.66,15.5-20.11v-17.75h-82.45c-8.69,0-16.79,4.37-21.56,11.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 819.97,
    y: 523.95,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 484.44,
    y: 523.95,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 395.61,
    y: 580.44,
    width: 463.89,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 395.61,
    y: 582.56,
    width: 463.89,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 395.61,
    y: 585.03,
    width: 463.89,
    height: 8.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 395.61,
    y: 622.01,
    width: 463.89,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 395.61,
    y: 624.12,
    width: 463.89,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 395.61,
    y: 626.6,
    width: 463.89,
    height: 8.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 2427.11,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 2440.99,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 2427.11,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 2440.99,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 2692.45,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 2706.34,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 2692.45,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 2706.34,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "2427.11 544.85 2427.11 585.57 2450.63 608.37 2476.18 608.37 2486.18 594.9 2652.64 594.9 2662.64 608.37 2688.19 608.37 2711.71 585.57 2711.71 544.85 2427.11 544.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M2694.22,594.66l-5.05-13.55c-2.32-6.23-7.8-8.64-12.24-5.39h0c-4.44,3.25-6.17,10.93-3.85,17.16l2.97,7.98h-98.58v-.59h-16.12v.59h-98.58l2.97-7.98c2.32-6.23.59-13.91-3.85-17.15h0c-4.44-3.25-9.92-.83-12.24,5.4l-5.04,13.55c-2.32,6.23-.59,13.9,3.85,17.15h0c4.01,2.93,8.83,1.22,11.45-3.7h22.85v3.63h8.98v3.63h14.23v3.63h15.72v3.63h20.23v3.63h19.44v2.37h16.12v-2.37h19.44v-3.63h20.23v-3.63h15.73v-3.63h14.22v-3.63h8.98v-3.63h22.85c2.61,4.92,7.44,6.63,11.45,3.7h0c4.44-3.25,6.17-10.93,3.85-17.16Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-152",
    cx: 2569.66,
    cy: 624.09,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M2569.41,533.19c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM2569.41,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2661.71,626.8v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.82l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.81c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.51-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.24-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM2569.41,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2569.41,541.72c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM2569.41,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M2569.41,566.61c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM2569.41,673.97c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M2569.41,572c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM2569.41,672.19c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M2569.38,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2536.61,591.54c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2528.57,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2547.88,660.34c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM2569.25,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2569.51,670.33c-5.67,0-10.28-2.42-10.28-5.4s4.6-5.4,10.28-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2590.88,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2602.15,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2610.19,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M2619.42,617.52c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM2544.25,599.18c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2569.25,588.71c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2605.41,602.44c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M2534.21,603.28c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08s8.98-5.56,11.08-3.45c1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM2569.25,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M2569.38,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2536.61,591.54c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2528.57,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2547.88,660.34c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM2569.25,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2569.51,670.33c-5.67,0-10.28-2.42-10.28-5.4s4.6-5.4,10.28-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2590.88,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2602.15,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2610.19,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "2571.88 645.21 2567.71 645.21 2565.63 648.82 2567.71 652.44 2571.88 652.44 2573.97 648.82 2571.88 645.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M2571.84,648.82c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "2586.09 637.27 2583.14 640.23 2584.22 644.25 2588.25 645.33 2591.2 642.38 2590.12 638.35 2586.09 637.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M2588.62,639.86c.8.8.8,2.1,0,2.89s-2.1.8-2.89,0c-.8-.8-.8-2.1,0-2.89s2.09-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "2590.53 621.62 2590.53 625.79 2594.14 627.87 2597.76 625.79 2597.76 621.62 2594.14 619.53 2590.53 621.62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-150",
    cx: 2594.14,
    cy: 623.7,
    r: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "2582.59 607.41 2585.54 610.36 2589.57 609.28 2590.65 605.25 2587.7 602.3 2583.67 603.38 2582.59 607.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M2585.18,604.88c.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89s-2.1.8-2.89,0c-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "2566.93 602.97 2571.11 602.97 2573.19 599.36 2571.11 595.74 2566.93 595.74 2564.85 599.36 2566.93 602.97"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-150",
    cx: 2569.02,
    cy: 599.36,
    r: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "2552.73 610.91 2555.68 607.96 2554.6 603.93 2550.57 602.85 2547.62 605.8 2548.7 609.83 2552.73 610.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M2550.2,608.32c-.8-.8-.8-2.09,0-2.89s2.1-.8,2.89,0c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "2548.29 626.56 2548.29 622.39 2544.68 620.31 2541.06 622.39 2541.06 626.56 2544.68 628.65 2548.29 626.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M2544.68,626.53c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "2556.22 640.77 2553.27 637.82 2549.24 638.9 2548.16 642.93 2551.11 645.88 2555.14 644.8 2556.22 640.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M2553.64,643.3c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.09,0-2.89.8-.8,2.09-.8,2.89,0,.8.8.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 2569.41,
    cy: 624.09,
    r: 18.8,
    transform: "translate(-43.24 1030.78) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 2569.41,
    cy: 624.09,
    r: 13.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M2793.18,502.25h36.11v47.75h-36.11c-5.94,0-10.76-4.82-10.76-10.76v-26.23c0-5.94,4.82-10.76,10.76-10.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M2828.36,527.94h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.72-2.56-5.72-5.71v-7.36c0-3.16,2.56-5.71,5.72-5.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 2829,
    y: 529.34,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2829.11,
    y: 529.66,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 2827.29,
    y: 529.34,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2827.4,
    y: 529.66,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 2825.58,
    y: 529.34,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2825.69,
    y: 529.66,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M2828.36,505.52h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.72-2.56-5.72-5.71v-7.36c0-3.16,2.56-5.71,5.72-5.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 2829,
    y: 506.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 2829.11,
    y: 507.24,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 2827.29,
    y: 506.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 2827.4,
    y: 507.24,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 2825.58,
    y: 506.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 2825.69,
    y: 507.24,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2801.24,
    y: 478.98,
    width: 15.99,
    height: 71.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 2809.23,
    y: 457.44,
    width: 15.99,
    height: 171.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 2809.23,
    y: 574.21,
    width: 15.99,
    height: 55.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 732.09,
    width: 2098.88,
    height: 484.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 738.99,
    y: 6,
    width: 2085.08,
    height: 472.98
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-175",
    points: "743.33 8.79 2824.07 8.79 2824.07 6 738.99 6 738.99 478.98 743.33 478.98 743.33 8.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M369.51,164.03v297h45.89c10.55,0,19.1-8.55,19.1-19.1V164.03h-64.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M369.51,164.03v297h45.89c10.55,0,19.1-8.55,19.1-19.1V164.03h-64.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M358.16,164.03v291.78h45.89c10.55,0,19.1-8.4,19.1-18.76V164.03h-64.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M369.51,217.62v243.41h28.1v-209.62c0-15.52-8.52-30.41-28.1-33.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M366.41,217.41c-20.38-3-252.29,2.4-263.68,7.79-11.39,5.4-74.34,176.26-74.34,206.04,0,38.17-2.8,68.16,2.8,89.94h145.21l5.17-4.8c15.78-14.64,36.51-22.78,58.03-22.78h135.61c5.17,0,9.36-4.19,9.36-9.36v-10.81c0-3.81,3.05-7.14,6.86-7.01,2.3.08,4.19-1.76,4.19-4.04v-210.96c0-15.82-8.82-31.01-29.21-34.01ZM239.02,363.06c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.59c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "165.54 521.19 33.88 521.19 33.88 594.03 66.75 594.03 66.75 633.1 74.54 633.1 74.54 594.03 116.51 594.03 116.51 633.1 124.31 633.1 124.31 594.03 135.96 594.03 165.54 521.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "133.03 568.75 66.75 568.75 66.75 528.58 151.29 528.58 133.03 568.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M125.48,564.15h-46.45c-4.11,0-7.45-3.34-7.45-7.45v-28.12h74.86l-14.19,31.21c-1.21,2.66-3.86,4.37-6.78,4.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 64.8,
    y: 626.53,
    width: 61.45,
    height: 6.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 64.8,
    y: 623.24,
    width: 61.45,
    height: 6.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M62.35,633.1H28.18c-15.56,0-28.18-39.53-28.18-54.76v-38.48c0-8.95,7.49-16.28,16.64-16.28h45.72v109.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.35,633.1H28.18c-15.56,0-28.18-39.53-28.18-54.76v-38.48c0-8.95,7.49-16.28,16.64-16.28h45.72v109.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 276.5,
    y: 259.98,
    width: 78.69,
    height: 113.32,
    rx: 5.78,
    ry: 5.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 278.8,
    y: 270.75,
    width: 74.08,
    height: 91.77,
    rx: 4.61,
    ry: 4.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M366.41,217.41c-20.38-3-252.29,2.4-263.68,7.79-11.39,5.4-74.34,176.26-74.34,206.04,0,38.17-2.8,68.16,2.8,89.94h145.21l5.17-4.8c15.78-14.64,36.51-22.78,58.03-22.78h135.61c5.17,0,9.36-4.19,9.36-9.36v-10.81c0-3.81,3.05-7.14,6.86-7.01,2.3.08,4.19-1.76,4.19-4.04v-210.96c0-15.82-8.82-31.01-29.21-34.01ZM239.02,363.06c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.59c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M334.16,434.76c-124.03,0-234.59,18.08-306.44,46.31.03,2.13.08,4.2.15,6.24,71.85-28.19,182.35-46.25,306.3-46.25,11.04,0,50.65.15,61.46.43v-6.3c-10.81-.28-50.42-.43-61.46-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M405.86,231.23l13.87-16.63c9.54-11.44,14.77-25.86,14.77-40.76v-23.52s-277.71,51.79-307.5,66.84c-29.79,15.04-26.66,15.7-26.66,15.7l290.14,5.55c5.94,0,11.58-2.64,15.38-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M127,198.51c-29.79,22.97-26.66,32.45-26.66,32.45l.2-.04c-.51,1.32-.2,1.95-.2,1.95h290.14c5.94,0,11.58-2.64,15.38-7.2l13.87-16.62c8.4-10.07,13.44-22.45,14.53-35.43l.23-.04V50.36S156.79,175.54,127,198.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M119.08,211.8c27.45-19.72,214.16-104.39,315.42-128.04v-33.4S156.79,175.54,127,198.51c-18.56,14.31-24.34,23.38-26.06,28.19,4.24-4.16,10.08-9.11,18.14-14.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127,198.51c-29.79,22.97-26.66,32.45-26.66,32.45l.2-.04c-.51,1.32-.2,1.95-.2,1.95h290.14c5.94,0,11.58-2.64,15.38-7.2l13.87-16.62c8.4-10.07,13.44-22.45,14.53-35.43l.23-.04V50.36S156.79,175.54,127,198.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M127,211.62c-29.79,15.04-26.66,21.26-26.66,21.26h290.14c5.94,0,11.58-2.64,15.38-7.2l13.87-16.63c1.22-1.46,2.36-2.98,3.44-4.53v-89.68c0-4.61-4.05-3.45-8.62-2.86-69.32,8.97-262.38,86.92-287.56,99.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M2713.18,680.08c-6.08-2.73-23.11-5.04-24.13-26.15-.48-9.85-.67-34.51-.81-46h-3.32v46.37c0,11.72,1.6,14.72,6.78,23.52,3.47,5.88,10.51,9.59,17.74,6.9l3.55-1.32c1.69-.63,1.82-2.59.19-3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M2493.99,521.01c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M2658.72,521.01c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M2684.92,613.3h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.45,115.45-115.45s115.45,51.79,115.45,115.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M2678.68,613.3h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 2732.72,
    y: 487.03,
    width: 31.33,
    height: 15.05,
    rx: 2.11,
    ry: 2.11,
    transform: "translate(5496.76 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 2734.09,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(5482.07 989.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 2734.63,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5470.89 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 2735.03,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5471.15 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 2736.87,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5475.36 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 2737.27,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5475.62 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 2739.1,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5479.84 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 2739.5,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5480.09 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 2741.34,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5484.31 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 2741.74,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5484.56 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M2744.04,489.76h.71c.25,0,.46.21.46.46v8.68c0,.25-.21.46-.46.46h-.71c-.25,0-.46-.21-.46-.46v-8.68c0-.25.21-.46.46-.46Z",
    transform: "translate(5488.78 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 2743.97,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5489.03 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 2745.81,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5493.25 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 2746.21,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5493.51 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 2748.79,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(5511.45 989.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 2749.32,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5500.27 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2749.72,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5500.53 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 2751.56,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5504.75 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2751.96,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5505 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M2754.25,489.76h.71c.25,0,.46.21.46.46v8.68c0,.25-.21.46-.46.46h-.71c-.25,0-.46-.21-.46-.46v-8.68c0-.25.21-.46.46-.46Z",
    transform: "translate(5509.22 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2754.19,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5509.47 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 2756.03,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5513.69 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2756.43,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5513.94 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M2758.73,489.76h.71c.25,0,.46.21.46.46v8.68c0,.25-.21.46-.46.46h-.71c-.25,0-.46-.21-.46-.46v-8.68c0-.25.21-.46.46-.46Z",
    transform: "translate(5518.16 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2758.66,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5518.42 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M2760.96,489.76h.71c.25,0,.46.21.46.46v8.68c0,.25-.21.46-.46.46h-.71c-.25,0-.46-.21-.46-.46v-8.68c0-.25.21-.46.46-.46Z",
    transform: "translate(5522.63 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2760.9,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5522.89 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 2074.52,
    y: 487.03,
    width: 31.33,
    height: 15.05,
    rx: 2.11,
    ry: 2.11,
    transform: "translate(4180.37 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 2075.9,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(4165.68 989.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 2076.44,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4154.5 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 2076.83,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4154.76 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 2078.67,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4158.97 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 2079.07,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4159.23 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 2080.91,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4163.44 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 2081.31,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4163.7 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M2083.6,489.76h.71c.25,0,.46.21.46.46v8.68c0,.25-.21.46-.46.46h-.71c-.25,0-.46-.21-.46-.46v-8.68c0-.25.21-.46.46-.46Z",
    transform: "translate(4167.92 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 2083.54,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4168.17 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 2085.38,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4172.39 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 2085.78,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4172.64 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 2087.61,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4176.86 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 2088.01,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4177.12 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 2090.59,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(4195.06 989.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 2091.13,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4183.88 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2091.53,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4184.14 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 2093.36,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4188.35 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2093.76,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4188.61 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 2095.6,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4192.83 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2096,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4193.08 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M2098.29,489.76h.71c.25,0,.46.21.46.46v8.68c0,.25-.21.46-.46.46h-.71c-.25,0-.46-.21-.46-.46v-8.68c0-.25.21-.46.46-.46Z",
    transform: "translate(4197.3 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2098.23,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4197.55 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 2100.07,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4201.77 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2100.47,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4202.02 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 2102.31,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4206.24 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2102.71,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4206.5 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 1416.33,
    y: 487.03,
    width: 31.33,
    height: 15.05,
    rx: 2.11,
    ry: 2.11,
    transform: "translate(2863.98 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1417.7,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(2849.29 989.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 1418.24,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(2838.11 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 1418.64,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(2838.36 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M1420.94,489.76h.71c.25,0,.46.21.46.46v8.68c0,.25-.21.46-.46.46h-.71c-.25,0-.46-.21-.46-.46v-8.68c0-.25.21-.46.46-.46Z",
    transform: "translate(2842.58 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 1420.88,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(2842.84 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 1422.71,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(2847.05 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 1423.11,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(2847.31 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M1425.41,489.76h.71c.25,0,.46.21.46.46v8.68c0,.25-.21.46-.46.46h-.71c-.25,0-.46-.21-.46-.46v-8.68c0-.25.21-.46.46-.46Z",
    transform: "translate(2851.52 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 1425.35,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(2851.78 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 1427.18,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(2856 989.12) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 1427.58,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(2856.25 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 1429.42,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(2860.47 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 1429.82,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(2860.72 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 1432.39,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(2878.67 989.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 1432.93,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(2867.49 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1433.33,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(2867.75 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1435.63,489.76h.71c.25,0,.46.21.46.46v8.68c0,.25-.21.46-.46.46h-.71c-.25,0-.46-.21-.46-.46v-8.68c0-.25.21-.46.46-.46Z",
    transform: "translate(2871.96 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1435.57,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(2872.22 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 1437.4,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(2876.43 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1437.8,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(2876.69 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 1439.64,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(2880.91 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1440.04,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(2881.16 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 1441.87,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(2885.38 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1442.27,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(2885.63 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 1444.11,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(2889.85 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1444.51,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(2890.11 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 758.13,
    y: 487.03,
    width: 31.33,
    height: 15.05,
    rx: 2.11,
    ry: 2.11,
    transform: "translate(1547.59 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 759.51,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(1532.9 989.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 760.04,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1521.72 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 760.44,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1521.97 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 762.28,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1526.19 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 762.68,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1526.45 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M764.98,489.76h.71c.25,0,.46.21.46.46v8.68c0,.25-.21.46-.46.46h-.71c-.25,0-.46-.21-.46-.46v-8.68c0-.25.21-.46.46-.46Z",
    transform: "translate(1530.66 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 764.92,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1530.92 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 766.75,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1535.13 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 767.15,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1535.39 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 768.99,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1539.6 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 769.39,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1539.86 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 771.22,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1544.08 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 771.62,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1544.33 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 774.2,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(1562.28 989.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 774.73,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1551.1 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 775.13,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1551.36 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 776.97,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1555.57 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 777.37,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1555.83 982.62) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 779.21,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1560.04 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 779.61,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1560.3 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 781.44,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1564.51 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 781.84,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1564.77 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 783.68,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1568.99 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 784.08,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1569.24 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 785.91,
    y: 489.76,
    width: 1.63,
    height: 9.6,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1573.46 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 786.31,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1573.71 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1611.97,666.29h0c-1.99,0-3.61-1.62-3.61-3.61v-53.66c0-1.99,1.61-3.61,3.61-3.61h0c1.99,0,3.61,1.62,3.61,3.61v53.66c0,1.99-1.61,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1905.82,666.29h0c-1.99,0-3.61-1.62-3.61-3.61v-53.66c0-1.99,1.62-3.61,3.61-3.61h0c1.99,0,3.61,1.62,3.61,3.61v53.66c0,1.99-1.61,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M2199.68,666.29h0c-1.99,0-3.61-1.62-3.61-3.61v-53.66c0-1.99,1.61-3.61,3.61-3.61h0c1.99,0,3.61,1.62,3.61,3.61v53.66c0,1.99-1.61,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1758.9,662.69h0c-1.99,0-3.61-1.61-3.61-3.61v-160.5c0-1.99,1.61-3.61,3.61-3.61h0c1.99,0,3.61,1.61,3.61,3.61v160.5c0,1.99-1.61,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2052.75,662.69h0c-1.99,0-3.61-1.61-3.61-3.61v-160.5c0-1.99,1.61-3.61,3.61-3.61h0c1.99,0,3.61,1.61,3.61,3.61v160.5c0,1.99-1.61,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1465.03,612.6h881.59c1.99,0,3.6-1.61,3.6-3.6s-1.61-3.6-3.6-3.6h-881.59c-1.99,0-3.6,1.61-3.6,3.6s1.61,3.6,3.6,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1465.03,558.92h881.59c1.99,0,3.6-1.61,3.6-3.6s-1.61-3.6-3.6-3.6h-881.59c-1.99,0-3.6,1.61-3.6,3.6s1.61,3.6,3.6,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1488.74,666.29h834.16c15.06,0,27.31-12.25,27.31-27.31v-140.41c0-1.99-1.61-3.6-3.6-3.6s-3.6,1.61-3.6,3.6v140.41c0,11.09-9.02,20.11-20.11,20.11h-834.16c-11.09,0-20.11-9.02-20.11-20.11v-140.41c0-1.99-1.61-3.6-3.6-3.6s-3.6,1.61-3.6,3.6v140.41c0,15.06,12.25,27.31,27.31,27.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M1575.45,612.6h32.91v46.49h-32.91v7.2h73.42v-7.2h-33.29v-46.49h33.29v-7.19h-73.42v7.19ZM1461.43,638.98c0,15.06,12.25,27.31,27.31,27.31h13.3v-7.2h-13.3c-11.09,0-20.11-9.02-20.11-20.11v-26.38h33.41v-7.19h-40.61v33.57ZM2309.61,605.41v7.19h33.41v26.38c0,11.09-9.02,20.11-20.11,20.11h-13.3v7.2h13.3c15.06,0,27.31-12.25,27.31-27.31v-33.57h-40.61ZM1869.12,612.6h33.1v46.49h-33.1v7.2h73.42v-7.2h-33.1v-46.49h33.1v-7.19h-73.42v7.19ZM1722.29,612.6h33v46.48s0,0,0,0h-33v7.2h73.42v-7.2h-33.2s0,0,0,0v-46.48h33.2v-7.19h-73.42v7.19ZM2162.78,612.6h33.29v46.49h-33.29v7.2h73.42v-7.2h-32.91v-46.49h32.91v-7.19h-73.42v7.19ZM2015.95,612.6h33.2v46.48s0,0,0,0h-33.2v7.2h73.42v-7.2h-33s0,0,0,0v-46.48h33v-7.19h-73.42v7.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M238.74,435.65h-22.7c-4.52,0-8.19-3.67-8.19-8.19h0c0-4.52,3.67-8.19,8.19-8.19h22.7c4.52,0,8.19,3.67,8.19,8.19h0c0,4.52-3.67,8.19-8.19,8.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 212.55,
    y: 423.89,
    width: 28.17,
    height: 7.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M213.45,431.03h-7.62c-1.97,0-3.57-1.6-3.57-3.57h0c0-1.97,1.6-3.57,3.57-3.57h7.62v7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M239.83,423.89h7.62c1.97,0,3.57,1.6,3.57,3.57h0c0,1.97-1.6,3.57-3.57,3.57h-7.62v-7.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 213.97,
    y: 424.89,
    width: 25.34,
    height: 5.14,
    rx: 1.11,
    ry: 1.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M380.6,535.42c0-25.52-20.69-46.21-46.21-46.21h-104.53c-30.03,0-57.31,17.48-69.85,44.76l-27.85,60.56h7.1c8.07,0,15.4-4.7,18.77-12.03l18.77-40.81c9.53-20.72,30.25-34,53.05-34h104.54c15.31,0,27.73,12.41,27.73,27.73v45.06c0,7.76,6.29,14.06,14.06,14.06h4.43v-59.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M366.19,526.98v108.78c0,15.09,1.6,18.96,6.78,30.3,3.47,7.57,10.51,12.35,17.74,8.88l3.55-1.7c1.69-.81,1.82-3.33.19-4.28-6.07-3.52-23.11-6.5-24.13-33.68-1.62-43.08.07-113.48-4.13-108.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M395.61,249.49H116.55c-8.54,0-16.2,5.07-19.52,12.93-10.67,25.25-35.48,90.47-35.48,150.45v108.32h2.4v-108.32c0-59.55,24.68-124.4,35.29-149.52,2.94-6.96,9.73-11.46,17.31-11.46h135.21c2.15.72,3.72,2.73,3.72,5.12v217.13c0,9.58-7.79,17.37-17.37,17.37h-5.71v1.8h5.71c10.57,0,19.17-8.6,19.17-19.17v-217.13c0-2-.82-3.81-2.14-5.12h140.47c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M385.31,533.18c0-26.49-21.47-47.96-47.96-47.96h-108.5c-31.17,0-59.48,18.14-72.5,46.46l-28.9,62.86h7.37c8.38,0,15.98-4.88,19.48-12.49l19.48-42.36c9.89-21.51,31.39-35.29,55.07-35.29h108.5c15.89,0,28.78,12.88,28.78,28.78v46.76c0,8.06,6.53,14.59,14.59,14.59h4.6v-61.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 73.19,
    y: 502.95,
    width: 20.71,
    height: 12.88,
    rx: 1.64,
    ry: 1.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M76.65,503.89h13.79c1.29,0,2.33,1.04,2.33,2.33v6.34c0,1.29-1.04,2.33-2.33,2.33h-13.79c-1.29,0-2.33-1.04-2.33-2.33v-6.34c0-1.29,1.04-2.33,2.33-2.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 89.89,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90.08,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 86.92,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 87.11,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 83.95,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.14,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 80.98,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 81.17,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 78.01,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 78.2,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 75.03,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 75.23,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M27.75,473.62h0c-.25,18.74.1,34.62,3.43,47.56h8.89v-35.24c0-6.8-5.52-12.32-12.32-12.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M41.27,485.94c0-7.45-6.06-13.52-13.52-13.52-.66,0-1.2.54-1.2,1.2s.54,1.2,1.2,1.2c6.13,0,11.12,4.99,11.12,11.12v35.24h2.4v-35.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M38.57,434.27c0-21.13,28.84-110.02,51.01-167.03,1.36-3.5-1.23-7.26-4.99-7.26h-.22c-22.55,52.9-55.99,149.56-55.99,171.26,0,2.71-.02,5.37-.04,8.01h5.3c2.72,0,4.94-2.2,4.94-4.93,0-.02,0-.03,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M91.39,418.55c-4.24,0-8.36-1.43-11.78-4.18-4.74-3.81-7.33-9.49-7.08-15.57,1.61-40.29,11.3-79.94,31.43-128.55,3.15-7.61,9.39-11.47,18.56-11.47h107.92c4.53,0,9.79,5.06,9.79,11.59v92.69c0,9.98-6.74,18.73-16.39,21.27l-127.56,33.58c-1.62.43-3.26.64-4.88.64ZM122.51,261.18c-8.21,0-13.56,3.27-16.34,9.99-20.01,48.34-29.65,87.73-31.25,127.73-.21,5.32,2.04,10.28,6.19,13.61,4.13,3.31,9.43,4.44,14.55,3.09l127.56-33.58c8.6-2.26,14.61-10.06,14.61-18.95v-92.69c0-4.95-4.07-9.19-7.39-9.19h-107.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M33.63,440.45h-5.3c-.66,0-1.2-.54-1.2-1.2s.54-1.2,1.2-1.2h5.3c2.06,0,3.74-1.67,3.74-3.73,0-22.09,30.26-113.96,51.09-167.51.5-1.29.34-2.68-.44-3.82-.79-1.15-2.04-1.81-3.43-1.81-.66,0-1.31-.54-1.31-1.2s.42-1.2,1.09-1.2c2.39,0,4.41,1.07,5.63,2.85,1.22,1.78,1.48,4.04.69,6.05-23.55,60.54-50.92,146.5-50.92,166.59,0,3.43-2.75,6.18-6.14,6.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M16.73,393.26c-.4.12-.83.17-1.27.14-1.82-.12-3.08-1.54-2.83-3.19,2.09-13.66-6.85-24.06-6.94-24.16-1.09-1.25-.8-3.13.67-4.21,1.46-1.08,3.54-.94,4.64.31.44.49,10.68,12.3,8.21,28.48-.19,1.25-1.2,2.26-2.47,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M7.69,363.1c-.43-.49-1.03-.76-1.67-.9-1.12,1.1-1.32,2.71-.33,3.84.09.1,3.87,7.76,6.94,24.16.28,1.48.82,2.75,2.37,3.07.47-.46.8-1.05.9-1.7,2.47-16.18-7.77-27.99-8.2-28.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M128.21,253.18h-4.65c-.96,0-1.78.58-2.17,1.4H23.95c-13.21,0-23.95,10.75-23.95,23.95v96.79c0,9.82,5.89,18.54,15,22.21l65.88,26.56c.03,1.3,1.08,2.35,2.39,2.35h4.65c1.32,0,2.4-1.07,2.4-2.4s-1.07-2.4-2.4-2.4h-4.65c-.44,0-.82.15-1.18.35l-66.2-26.69c-5.23-2.11-9.27-6.08-11.51-10.97l7.92-3.19c.63-.25.94-.97.68-1.61-.26-.63-.97-.94-1.61-.68l-7.89,3.18c-.69-2.13-1.09-4.39-1.09-6.72v-62.87h12.78c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2H2.4v-31.52c0-11.89,9.67-21.55,21.55-21.55h97.71c.44.59,1.1,1,1.9,1h4.65c1.32,0,2.4-1.07,2.4-2.4s-1.07-2.4-2.4-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M21.89,310.34c0,22.88-2.73,41.43-6.1,41.43s-6.1-18.55-6.1-41.43,2.73-41.43,6.1-41.43,6.1,18.55,6.1,41.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M16.55,267.81h.98v85.07h-.98c-4.61,0-8.34-3.74-8.34-8.34v-68.38c0-4.61,3.74-8.34,8.34-8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M8.21,276.08h.1c1.8,0,3.25,1.46,3.25,3.25v62.02c0,1.8-1.46,3.25-3.25,3.25h-.1v-68.53h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3AxSingle);
export default __webpack_public_path__ + "static/media/3-Ax Single.c6456276f751dc401ba881e36e718a28.svg";
export { ForwardRef as ReactComponent };